import Vue from 'vue'
import VueRouter from 'vue-router'
import Http from '../lib/http'
import Api from '../lib/api'
import Common from '../lib/common'
import { Toast } from 'vant'
import common from '../lib/common'
// import Store from '../store/index'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'Home',
  component: () => import('../views/home/Index.vue'),
  meta: {
    title: '遵义市新区供水责任有限公司网上营业厅',
    requireAuth: false,
    keepAlive: false
  }
},
{
  path: '/home/register',
  name: 'Register',
  component: () => import('../views/home/Register.vue'),
  meta: {
    title: '我要注册',
    keepAlive: false,
    requireAuth: false
  }
},
{
  path: '/home/faq',
  name: 'Faq',
  component: () => import('../views/home/Faq.vue'),
  meta: {
    title: '业务常识',
    keepAlive: true,
    isUseCache: false
  }
},
{
  path: '/business',
  name: 'Business',
  component: () => import('../views/business/Index.vue'),
  meta: {
    title: '业务办理',
    keepAlive: false,
  }
},
{
  path: '/business/success',
  name: 'BusinessSuccess',
  component: () => import('../views/business/BusinessSuccess.vue'),
  meta: {
    title: '提交成功',
    keepAlive: false,
  }
},
{
  path: '/business/transfer/meterTransfer',
  name: 'MeterTransfer',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '过户申请',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/meterTransferForm',
  name: 'MeterTransferForm',
  component: () => import('../views/business/transfer/MeterTransferForm.vue'),
  meta: {
    title: '过户申请',
    keepAlive: false,
    requireAuth: true
  }
},
{
  path: '/business/catchWater',
  name: 'CatchWater',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '新户报装',
    keepAlive: false,
    requireAuth: false
  }
},
{
  path: '/business/catchForm',
  name: 'CatchForm',
  component: () => import('../views/business/catch/CatchForm.vue'),
  meta: {
    title: '新户报装',
    keepAlive: false
  }
},
{
  path: '/business/meterRemodel',
  name: 'MeterRemodel',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '退费申请',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/business/remodelForm',
  name: 'RemodelForm',
  component: () => import('../views/business/remodel/RemodelForm.vue'),
  meta: {
    title: '退费申请',
    keepAlive: false,
    requireAuth: true
  }
},
{
  path: '/business/infoChange',
  name: 'InfoChange',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '客户信息变更',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/business/changeForm',
  name: 'ChangeForm',
  component: () => import('../views/business/info/ChangeForm.vue'),
  meta: {
    title: '客户信息变更',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/business/reconnect',
  name: 'Reconnect',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '报停复水申请',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/business/reconnectForm',
  name: 'ReconnectForm',
  component: () => import('../views/business/reconnect/ReconnectForm.vue'),
  meta: {
    title: '报停复水申请',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/business/destroy',
  name: 'Destroy',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '销户申请',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/business/destroyForm',
  name: 'DestroyForm',
  component: () => import('../views/business/destroy/DestroyForm.vue'),
  meta: {
    title: '销户申请',
    keepAlive: true,
    requireBind: true
  }
},
{
  path: '/business/check',
  name: 'Check',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '检表申请',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/business/checkForm',
  name: 'CheckForm',
  component: () => import('../views/business/check/CheckForm.vue'),
  meta: {
    title: '检表申请',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/business/stop',
  name: 'Stop',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '报停申请',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/business/stopForm',
  name: 'StopForm',
  component: () => import('../views/business/stop/StopForm.vue'),
  meta: {
    title: '报停申请',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/business/nature',
  name: 'Nature',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '用水性质变更',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/business/natureForm',
  name: 'NatureForm',
  component: () => import('../views/business/nature/NatureForm.vue'),
  meta: {
    title: '用水性质变更',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/company/changeWaterMaster',
  name: 'changeWaterMaster',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '单位水表过户',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/company/changeWaterMasterForm',
  name: 'changeWaterMasterForm',
  component: () => import('../views/business/company/changeWaterMaster/changeWaterMasterForm'),
  meta: {
    title: '单位水表过户',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/company/destroyWater',
  name: 'destroyWater',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '单位销户申请',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/company/destroyWaterForm',
  name: 'destroyWaterForm',
  component: () => import('../views/business/company/destroyWater/destroyWaterForm'),
  meta: {
    title: '单位销户申请',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/company/connectWater',
  name: 'connectWater',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '单位报停复水申请',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/company/connectWaterForm',
  name: 'connectWaterForm',
  component: () => import('../views/business/company/connectWater/connectWaterForm'),
  meta: {
    title: '单位报停复水申请',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/company/catchWater',
  name: 'catchWater',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '单位报停申请',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/company/catchWaterForm',
  name: 'catchWaterForm',
  component: () => import('../views/business/company/catchWater/catchWaterForm'),
  meta: {
    title: '单位报停申请',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/company/changeWaterNature',
  name: 'changeWaterNature',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '单位用水性质变更',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/company/changeWaterNatureForm',
  name: 'changeWaterNatureForm',
  component: () => import('../views/business/company/changeWaterNature/changeWaterNatureForm'),
  meta: {
    title: '单位用水性质变更',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/company/applyTax',
  name: 'applyTax',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '增值税专票申请',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/company/applyTaxForm',
  name: 'applyTaxForm',
  component: () => import('../views/business/company/applyTax/applyTaxForm'),
  meta: {
    title: '增值税专票申请',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/company/changeTax',
  name: 'changeTax',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '增值税信息变更',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/company/changeTaxForm',
  name: 'changeTaxForm',
  component: () => import('../views/business/company/changeTax/changeTaxForm'),
  meta: {
    title: '增值税信息变更',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/company/returnTax',
  name: 'returnTax',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '增值税专票撤销',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/company/returnTaxForm',
  name: 'returnTaxForm',
  component: () => import('../views/business/company/returnTax/returnTaxForm'),
  meta: {
    title: '增值税专票撤销',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/company/remoldWater',
  name: 'remoldWater',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '单位退费申请',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/company/remoldWaterForm',
  name: 'remoldWaterForm',
  component: () => import('../views/business/company/remoldWater/remoldWaterForm'),
  meta: {
    title: '单位退费申请',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/company/movePipe',
  name: 'movePipe',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '单位检表申请',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/company/movePipeForm',
  name: 'movePipeForm',
  component: () => import('../views/business/company/movePipe/movePipeForm'),
  meta: {
    title: '单位检表申请',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/company/peopleWater',
  name: 'peopleWater',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '单位新户报装',
    keepAlive: false,
    requireAuth: false
  }
},
{
  path: '/company/peopleWaterForm',
  name: 'peopleWaterForm',
  component: () => import('../views/business/company/peopleWater/peopleWaterForm'),
  meta: {
    title: '单位新户报装',
    keepAlive: false,
    requireBind: false
  }
},
{
  path: '/company/moveWater',
  name: 'moveWater',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '水表移位工程',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/company/moveWaterForm',
  name: 'moveWaterForm',
  component: () => import('../views/business/company/moveWater/moveWaterForm'),
  meta: {
    title: '水表移位工程',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/company/unInvokePro',
  name: 'unInvokePro',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '不涉及工程项目报装',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/company/unInvokeProForm',
  name: 'unInvokeProForm',
  component: () => import('../views/business/company/unInvokePro/unInvokeProForm'),
  meta: {
    title: '不涉及工程项目报装',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/company/buildPro',
  name: 'buildPro',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '新建及改扩建,基建接水项目用水报装',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/company/buildProForm',
  name: 'buildProForm',
  component: () => import('../views/business/company/buildPro/buildProForm'),
  meta: {
    title: '新建及改扩建,基建接水项目用水报装',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/company/changeWater',
  name: 'movePipe',
  component: () => import('../views/business/KnowPage'),
  meta: {
    title: '单位水表变更',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/company/changeWaterForm',
  name: 'changeWaterForm',
  component: () => import('../views/business/company/changeWater/changeWaterForm'),
  meta: {
    title: '单位水表变更',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/guide/mustKnow',
  name: 'MustKnow',
  component: () => import('../views/guide/MustKnow.vue'),
  meta: {
    title: '办事指南',
    keepAlive: true,
    isUseCache: false
  }
},
{
  path: '/guide/articleDetail',
  name: 'ArticleDetail',
  component: () => import('../views/guide/ArticleDetail.vue'),
  meta: {
    title: '办事指南',
    keepAlive: false
  }
},
{
  path: '/butler',
  name: 'Butler',
  component: () => import('../views/butler/Index.vue'),
  meta: {
    title: '水管家服务',
    keepAlive: false
  }
},
{
  path: '/butler/breakdown',
  name: 'Breakdown',
  component: () => import('../views/butler/KnowPage'),
  meta: {
    title: '故障报修',
    keepAlive: false,
    requireAuth: true
  }
},
{
  path: '/butler/breakdown/form',
  name: 'BreakdownForm',
  component: () => import('../views/butler/breakdown/Form.vue'),
  meta: {
    title: '故障报修',
    keepAlive: false
  }
},
{
  path: '/repair',
  name: 'repair',
  component: () => import('../views/repair'),
  meta: {
    title: '故障报修',
    keepAlive: false
  }
},
{
  path: '/sw',
  name: 'sw',
  component: () => import('../views/sw'),
  meta: {
    title: '',
    keepAlive: false,
    requireAuth: false,
    requireBind: false
  }
},
{
  path: '/butler/advice',
  name: 'Advice',
  component: () => import('../views/butler/KnowPage'),
  meta: {
    title: '投诉建议',
    keepAlive: false,
    requireAuth: true
  }
},
{
  path: '/butler/advice/form',
  name: 'AdviceForm',
  component: () => import('../views/butler/advice/Form.vue'),
  meta: {
    title: '投诉建议',
    keepAlive: false
  }
},
{
  path: '/butler/leak',
  name: 'Leak',
  component: () => import('../views/butler/KnowPage'),
  meta: {
    title: '表后设施检漏申请',
    keepAlive: false,
    requireAuth: true
  }
},
{
  path: '/butler/leak/form',
  name: 'LeakForm',
  component: () => import('../views/butler/leak/Form.vue'),
  meta: {
    title: '表后设施检漏申请',
    keepAlive: false
  }
},
{
  path: '/butler/monitor',
  name: 'Monitor',
  component: () => import('../views/butler/KnowPage'),
  meta: {
    title: '水质检测申请',
    keepAlive: false,
    requireAuth: true
  }
},
{
  path: '/butler/monitor/form',
  name: 'MonitorForm',
  component: () => import('../views/butler/monitor/Form.vue'),
  meta: {
    title: '水质检测申请',
    keepAlive: false
  }
},
{
  path: '/butler/read',
  name: 'Read',
  component: () => import('../views/butler/KnowPage'),
  meta: {
    title: '网上抄表',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/butler/read/form',
  name: 'ReadForm',
  component: () => import('../views/butler/read/Form.vue'),
  meta: {
    title: '网上抄表',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/butler/paysewage',
  name: 'Read',
  component: () => import('../views/butler/KnowPage'),
  meta: {
    title: '非居民污水处理费缓交申请',
    keepAlive: false,
    requireAuth: true,
    requireBind: true
  }
},
{
  path: '/butler/paysewage/form',
  name: 'ReadForm',
  component: () => import('../views/butler/paysewage/Form.vue'),
  meta: {
    title: '非居民污水处理费缓交申请',
    keepAlive: false,
    requireBind: true
  }
},
{
  path: '/butlerServe',
  name: 'ButlerServe',
  component: () => import('../views/butler/ButlerServe.vue'),
  meta: {
    title: '“水管家”信息服务',
    keepAlive: true,
    isUseCache: false
  }
},
{
  path: '/personCenter',
  name: 'PersonCenter',
  component: () => import('../views/mine/Index.vue'),
  meta: {
    title: '个人中心',
    keepAlive: false,
    requireAuth: true
  }
},
{
  path: '/mine/readRecords',
  name: 'ReadRecords',
  component: () => import('../views/mine/ReadRecords.vue'),
  meta: {
    title: '网上抄表记录',
    keepAlive: false,
    requireAuth: true
  }
},
{
  path: '/mine/registerInfo',
  name: 'RegisterInfo',
  component: () => import('../views/mine/RegisterInfo.vue'),
  meta: {
    title: '注册信息',
    keepAlive: false
  }
},
{
  path: '/mine/registerModify',
  name: 'RegisterModify',
  component: () => import('../views/mine/RegisterModify.vue'),
  meta: {
    title: '注册信息修改',
    keepAlive: false
  }
},
{
  path: '/mine/registerOk',
  name: 'RegisterOk',
  component: () => import('../views/mine/RegisterOk.vue'),
  meta: {
    title: '完善注册信息',
    keepAlive: false
  }
},
{
  path: '/mine/pwdModify',
  name: 'PwdModify',
  component: () => import('../views/mine/PwdModify.vue'),
  meta: {
    title: '密码修改',
    keepAlive: false
  }
},
{
  path: '/bindManage',
  name: 'BindManage',
  component: () => import('../views/mine/BindManage.vue'),
  meta: {
    title: '绑定列表',
    keepAlive: false,
    requireAuth: true
  }
},
{
  path: '/mine/codeBind',
  name: 'CodeBind',
  component: () => import('../views/mine/BindCode.vue'),
  meta: {
    title: '户号绑定',
    keepAlive: false,
    requireAuth: true
  }
},
{
  path: '/mine/businessProgress',
  name: 'BusinessProgress',
  component: () => import('../views/mine/BussProgress.vue'),
  meta: {
    title: '业务办理进度查询',
    keepAlive: true,
    isUseCache: false
  }
},
{
  path: '/mine/butlerProgress',
  name: 'ButlerProgress',
  component: () => import('../views/mine/ButlerProgress.vue'),
  meta: {
    title: '客户服务工单查询',
    keepAlive: true,
    isUseCache: false
  }
},
{
  path: '/pay/feePay',
  name: 'FeePay',
  component: () => import('../views/pay/FeePay.vue'),
  meta: {
    title: '费用查缴',
    keepAlive: false,
    requireBind: true,
    requireAuth: true
  }
},
{
  path: '/home/infoQuery',
  name: 'InfoQuery',
  component: () => import('../views/home/InfoQuery.vue'),
  meta: {
    title: '客户信息查询',
    keepAlive: false,
    requireBind: true,
    requireAuth: true
  }
},
{
  path: '/pay/feeList',
  name: 'FeeList',
  component: () => import('../views/pay/FeeList.vue'),
  meta: {
    title: '水费清单',
    keepAlive: false,
    requireBind: true,
    requireAuth: true
  }
},
{
  path: '/pay/invoiceApply',
  name: 'InvoiceApply',
  component: () => import('../views/pay/InvoiceApply.vue'),
  meta: {
    title: '电子发票',
    keepAlive: false,
    requireBind: true,
    requireAuth: true
  }
},
{
  path: '/mine/payRecords',
  name: 'PayRecords',
  component: () => import('../views/mine/PayRecords.vue'),
  meta: {
    title: '工程款缴费记录',
    keepAlive: false,
    requireAuth: true
  }
},
{
  path: '/mine/elecContract',
  name: 'elecContract',
  component: () => import('../views/mine/elecContract/index.vue'),
  meta: {
    title: '电子合同',
    keepAlive: false,
    requireAuth: true
  }
},
{
  path: '/scanBind',
  name: 'scanBind',
  component: () => import('../views/scanBind.vue'),
  meta: {
    title: '微信公众号扫码绑定',
    keepAlive: false,
    requireAuth: false
  }
},
{
  path: '/scanBindSuccess',
  name: 'scanBindSuccess',
  component: () => import('../views/scanBindSuccess.vue'),
  meta: {
    title: '微信公众号扫码绑定成功',
    keepAlive: false,
    requireAuth: false
  }
},
{
  path: '/intelligence/home',
  name: 'intelligence',
  component: () => import('../views/intelligence/home.vue'),
  meta: {
    title: '智水中心',
    keepAlive: false,
    requireAuth: false,
    // requireBind:true
  }
},
{
  path: '/workSheet/list',
  name: 'workSheetList',
  component: () => import('../views/intelligence/workSheet/list.vue'),
  meta: {
    title: '热线工单',
    keepAlive: false,
    requireAuth: false
  }
},
{
  path: '/workSheet/maintainerInfo',
  name: 'maintainerInfo',
  component: () => import('../views/intelligence/workSheet/maintainerInfo.vue'),
  meta: {
    title: '维修人员信息',
    keepAlive: false,
    requireAuth: false
  }
},
{
  path: '/workSheet/positionDetail',
  name: 'positionDetail',
  component: () => import('../views/intelligence/workSheet/positionDetail.vue'),
  meta: {
    title: '热线工单',
    keepAlive: false,
    requireAuth: false
  }
},
{
  path: '/workSheet/progressDetail',
  name: 'progressDetail',
  component: () => import('../views/intelligence/workSheet/progressDetail.vue'),
  meta: {
    title: '工单进度',
    keepAlive: false,
    requireAuth: false
  }
},
{
  path: '/workSheet/lineFeed',
  name: 'lineFeed',
  component: () => import('../views/intelligence/lineFeed/lineFeed.vue'),
  meta: {
    title: '换表查询',
    keepAlive: false,
    requireAuth: false
  }
},
{
  path: '/workSheet/userService',
  name: 'userService',
  component: () => import('../views/intelligence/userService/userService.vue'),
  meta: {
    title: '大用户服务',
    keepAlive: false,
    requireAuth: false
  }
},
{
  path: '/workSheet/schedule',
  name: 'schedule',
  component: () => import('../views/intelligence/schedule/schedule.vue'),
  meta: {
    title: '报装进度查询',
    keepAlive: false,
    requireAuth: false
  }
},
{
  path: '/workSheet/picture',
  name: 'picture',
  component: () => import('../views/intelligence/picture/picture.vue'),
  meta: {
    title: '作业一张图',
    keepAlive: false,
    requireAuth: false
  }
},
{
  path: '/workSheet/project',
  name: 'project',
  component: () => import('../views/intelligence/project/project.vue'),
  meta: {
    title: '工程一张图',
    keepAlive: false,
    requireAuth: false
  }
}

]

const router = new VueRouter({
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

router.afterEach(() => {
  window.scrollTo(0, 0);
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  //微信code
  let code = Common.GetQueryString('code')
  //度量云token
  let token = common.GetQueryString('token')
  localStorage.setItem("token", token);
  localStorage.setItem("code", code);
  localStorage.setItem("from", from.fullPath);
  localStorage.setItem("to", to.fullPath);
  //需要获取微信授权
  if (to.meta.requireAuth) {
    if (token && token !== '') {
      getUserInfo(code, token, to, next)
    } else {
      /**
       * todo：通过接口判断是否已注册（能获取到token）,并存入storage
       * 1.根据公众号配置的授权菜单拿到code
       * 2.根据code拿到access_token（后端接口）
       * 3.将access_token存入localStorage
      */
      if ((!localStorage.getItem('access_token') || !localStorage.getItem("cuser_info"))) {
        getUserInfo(code, token, to, next)
      } else {
        // checkinfo(to,next)
        checkbind(to, next)
      }
    }
  } else {
    checkbind(to, next)
  }
})

//获取用户信息
const getUserInfo = (code, token, to, next) => {
  localStorage.clear()
  let apiurl = Api.getOauth2
  if (token && token !== '') {
    apiurl = Api.getdlLogin
    code = token
  } else {
    token = ''
  }
  Http.get(apiurl, {
    code: code
  }).then(res => {
    if (res.code === '000') {
      let access_token = res.data.access_token;
      let refresh_token = res.data.refresh_token;
      let token = res.data.token;
      let nickname = res.data.nickname;
      let avatar = res.data.avatar;
      let flag = 1;
      // if(res.data.mobile=="18321264398" || res.data.mobile=="18357502925"){
      //   flag=1
      // }else{
      //   flag=0
      // }
      if (access_token) { // 已注册，更新token
        localStorage.setItem('access_token', access_token)
        localStorage.setItem('refresh_token', refresh_token)
        localStorage.setItem('token', token)
        localStorage.setItem('nickname', nickname)
        localStorage.setItem('avatar', avatar)
        localStorage.setItem('cuser_info', JSON.stringify(res.data))
        localStorage.setItem('mobile', flag);
        //localStorage.setItem('initdata', "4");  //标志

        // checkinfo(to,next)
      }
      //获取绑定用户
      Http.post(Api.userList, {}).then(res => {
        if (res.code === '000') {
          if (res.data != null && res.data.length > 0) { // 已绑定
            localStorage.setItem('userList', JSON.stringify(res.data))
          }
        }
        checkbind(to, next)
      })
    } else {
      Toast(res.msg)
    }
  }).catch((e) => {
    Toast(e.message)
  })
}

//检查姓名手机号
// const checkinfo=(to,next)=>{
//   let cuser_info = null
//   if(localStorage.getItem('cuser_info')){
//     cuser_info = JSON.parse(localStorage.getItem('cuser_info'))
//   }
//   if(cuser_info===null || cuser_info.mobile===null || cuser_info.mobile===''){
//     next('/mine/registerOk');
//   }
// }

//需要绑定户号引导到绑定页面
const checkbind = (to, next) => {
  if (to.meta.requireBind) {
    let userList = localStorage.getItem('userList')
    if (userList === 'null' || !userList || typeof userList === 'undefined' || userList.length === 0) {
      next('/mine/codeBind')
    } else {
      next()
    }
  } else {
    next()
  }
}

export default router
